var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stack"},_vm._l((_vm.stack),function(card,i){return (i < 8)?_c('Card',{key:'field-' + i,style:({ zIndex: 8 - i, transform: 'rotate(' + _vm.getStackRotation(i, _vm.stack.length) + ') translate(-50%, -50%)' }),attrs:{"selectable":false,"animateDisabled":true,"color":card.color,"type":card.type}}):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7300438a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardStack.vue
// module id = null
// module chunks = 